var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('CrowdFundingBody',{attrs:{"crowdfunding":_vm.crowdfunding.allcrowdfunding,"loading":_vm.crowdfunding.loading,"user":_vm.admin.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }